var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutplusdry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 34,
    viewBox: "0 0 161 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4495_9949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3496 12.6257H70.0762V19.8083H77.3496V12.6257Z",
    fill: "#989BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6182 12.6257H77.3447V19.8083H84.6182V12.6257Z",
    fill: "#DCFE07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8916 12.6257H84.6182V19.8083H91.8916V12.6257Z",
    fill: "#989BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6182 5.44305H77.3447V12.6256H84.6182V5.44305Z",
    fill: "#989BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6182 19.8082H77.3447V26.9908H84.6182V19.8082Z",
    fill: "#989BA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8258 26.9908C5.91355 26.9908 0 21.2009 0 13.5133C0 5.82566 5.91355 0 13.8258 0C20.6408 0 25.9207 4.44321 26.9767 10.9575H19.7187C18.8275 8.32018 16.5765 6.61125 13.8412 6.61125C10.1581 6.61125 7.4589 9.53428 7.4589 13.5133C7.4589 17.4923 10.1581 20.3592 13.8412 20.3592C16.7259 20.3592 18.9975 18.5023 19.7239 15.6456H27.054C26.065 22.3997 20.7541 26.9857 13.8258 26.9857",
    fill: "#0B0814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0273 17.3749V5.49408H36.2854V17.0587C36.2854 19.2573 37.4804 20.5479 39.4173 20.5479C41.3541 20.5479 42.5286 19.2369 42.5286 17.0587V5.49408H49.7866V17.3698C49.7866 23.1955 45.6399 26.9858 39.4173 26.9858C33.1946 26.9858 29.0273 23.1904 29.0273 17.3698",
    fill: "#0B0814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1042 20.7111V26.9908H63.1127C58.4509 26.9908 55.6229 24.1749 55.6229 19.5532V11.7023H51.7646V10.024L61.2016 0.0917969H62.6903V5.44303H67.9806V11.6972H62.8706V18.3187C62.8706 19.8082 63.7823 20.706 65.3122 20.706H68.099L68.1042 20.7111Z",
    fill: "#0B0814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.013 13.4776C119.013 21.3488 113.161 26.9908 104.914 26.9908H93.8594V0.0101929H104.914C113.181 0.0101929 119.013 5.59609 119.013 13.4776ZM111.301 13.4776C111.301 9.47306 108.607 6.81529 104.558 6.81529H101.416V20.1806H104.558C108.602 20.1806 111.301 17.4566 111.301 13.4776Z",
    fill: "#0B0814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.708 5.44305V11.937H131.89C129.32 11.937 128.243 13.35 128.243 16.0843V26.9908H120.985V5.54508H125.848L126.981 7.92738C128.465 6.17764 130.278 5.44816 132.782 5.44816H134.703L134.708 5.44305Z",
    fill: "#0B0814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 5.44309L152.171 25.3279C149.333 31.6994 146.721 34 141.282 34H138.794V27.8377H140.792C143.569 27.8377 144.408 27.1235 145.387 24.5321L136.682 5.43799H144.568L149.039 16.9006L153.207 5.43799H161V5.44309Z",
    fill: "#0B0814"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4495_9949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutplusdry);
export default __webpack_public_path__ + "static/media/cutplusdry.05b97c6789737c08885fa5d9f49e41d0.svg";
export { ForwardRef as ReactComponent };